module.exports = __webpack_public_path__ + "static/09-1-21c9318e5e995189e3613c78ab3bd03c.jpg";